import React from 'react';

const AdaptiveCardContext = React.createContext({});

export {AdaptiveCardContext as default};
